import { DefaultRenderPathResolver } from '../DefaultRenderPathResolver.js';
import { VtkGeometry3DPath } from './VtkGeometry3DRenderPath.js';
import { VtkVolume3DPath } from './VtkVolume3DRenderPath.js';
export function createDefaultVolume3DRenderPaths() {
    return [new VtkVolume3DPath(), new VtkGeometry3DPath()];
}
export function createVolume3DRenderPathResolver(paths = createDefaultVolume3DRenderPaths()) {
    return new DefaultRenderPathResolver(paths);
}
